<template>
    <div class="context" id="page">
        <div class="header" id="header">
            <div class="search_box">
                <el-form :model="searchForm" class="search_form" size="small">
                    <el-form-item label="标题:">
                        <div class="radio_box">
                            <el-input
                                    class="width_220"
                                    @change="getTableData()"
                                    placeholder="请输入视频标题"
                                    clearable
                                    v-model="searchForm.input"
                            >
                            </el-input>
                            <div class="search_btn">
                                <el-button type="primary" @click="getTableData()">
                                    搜索
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="分类:">
                        <div class="input_box">
                            <div
                                    :class="searchForm.classification === '' ? 'actived_btn' : ''"
                                    @click="clearSearch('classification')"
                                    class="btn"
                            >
                                不限
                            </div>
                            <div
                                    v-for="(item, index) in videoClassifyList"
                                    :key="index"
                                    :class="
                  searchForm.classification === item.value ? 'actived_btn' : ''
                "
                                    @click="changeCell(item.value, 'classification')"
                                    class="btn"
                            >
                                {{ item.value }}
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="标签:">
                        <div class="check_box">
                            <div class="all_check">
                                <el-checkbox
                                        :indeterminate="isIndeterminate"
                                        v-model="checkAll"
                                        @change="handleCheckAllChange"
                                >
                                    全选
                                </el-checkbox>
                            </div>
                            <div class="check_btn">
                                <el-checkbox-group
                                        v-model="searchForm.tags"
                                        @change="handleCheckedCitiesChange"
                                >
                                    <el-checkbox
                                            v-for="(item, index) in tag_list"
                                            :label="item"
                                            :key="index"
                                    >
                                        {{ item }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="btn">
                    <el-button
                            size="small"
                            type="primary"
                            @click="uploadVideo"
                    >上传视频
                    </el-button
                    >
                </div>
            </div>
        </div>
        <div class="table_box" :style="{ height: tableHeight + 'px' }">
            <el-card
                    shadow="never"
                    v-for="(item, index) in tableData"
                    :key="index"
                    class="card_item"
            >
                <!-- <div class="img_box">
                  <img :src="showImgUrl(item)" alt="" />
                </div> -->
                <div class="title">{{ item.title }}</div>
                <!-- <div class="text">{{ item.digest }}</div> -->
                <div class="flex_box date">
                    <div>{{ item.update_time }}</div>
                    <div class="icon_box">
                        <i @click="edit_item(item, index)" class="el-icon-edit click_icon" style="color: #337ab7;"></i>
                        <i @click="del_item(item)" class="el-icon-delete click_icon table_del_btn"></i>
                        <el-popover placement="left" width="200" trigger="click">
                            <div class="qrcode" style="height: 200px">
                                <img :src="item.url" alt="加载失败" srcset="" style="width:100%;height:100%;">
                            </div>
                            <span
                                    slot="reference"
                                    style="cursor: pointer"
                                    class="iconfont icon-erweima"
                            ></span>
                        </el-popover>
                    </div>
                </div>
                <div class="flex_box">
                    <div class="title_f">分类：</div>
                    <div class="text_f select">
                        <el-dropdown
                                trigger="click"
                                @command="(com) => select_class(com, item, index)"
                        >
                            <span v-if="item.cate" class="el-dropdown-link">
                              {{ item.cate }}
                              <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <span v-else class="el-dropdown-link add_class">+</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                        v-for="(items, indexs) in videoClassifyList"
                                        :command="items.value"
                                        :key="indexs"
                                >
                                    {{ items.value }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="flex_box">
                    <div class="title_f">标签：</div>
                    <div class="text_f tags">
                        <el-tag
                                :key="tag"
                                v-for="tag in item.tags"
                                closable
                                size="small"
                                class="tag_item"
                                :disable-transitions="false"
                                @close="handleClose(tag, item, index)"
                        >
                            {{ tag }}
                        </el-tag>
                        <el-input
                                class="input-new-tag"
                                v-if="item.inputVisible"
                                v-model="item.inputValue"
                                ref="saveTagInput"
                                size="mini"
                                @input="changeInput"
                                @change="handleInputConfirm(item, index)"
                        >
                        </el-input>
                        <el-button
                                v-else
                                class="button-new-tag"
                                size="mini"
                                @click="showInput(item, index)"
                        >+ 新标签
                        </el-button>
                    </div>
                </div>
                <div class="flex_box bottom_flex">
                    <div class="title_f">积分：</div>
                    <div class="text_f input_num"
                         v-if="!item.showScoreEdit"
                         @click="openScoreEdit(item)">
                        <span>{{item.score || '默认'}}</span>
                    </div>
                    <div class="text_f input_num" v-else>
                        <el-input-number v-model="item.score"
                                         class="width_100"
                                         controls-position="right"
                                         size="mini"
                                         :max="100"
                                         :min="1"></el-input-number>
                        <el-button size="mini"
                                   type="primary"
                                   plain
                                   style="margin-left: 5px"
                                   @click="changeScore(item)">
                            确定
                        </el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="bottom_page" id="bottom_page">
            <page-view
                    @getTableList="handleCurrentChange"
                    :currentPage="currentPage"
                    :pageSize="pageSize"
                    :total="total"
            ></page-view>
        </div>

        <el-dialog title="修改视频名称"
                   :visible.sync="dialogVisible"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   top="8vh"
                   width="500px">
            <el-form :model="edit_form" ref="edit_form" :rules="edit_rules" label-width="120px">
                <el-form-item label="视频名称" prop="title">
                    <el-input v-model="edit_form.title" type="textarea" class="width_all"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {clone} from "@/global/utils";
    import {langRequest, getQrImageUrl} from "../../api/index";
    import vueQr from "vue-qr";

    export default {
        name: "courseView",
        components: {
            vueQr,
        },
        data() {
            return {
                imageUrl: "",
                tableHeight: 0,
                searchForm: {
                    input: "",
                    classification: "",
                    tags: [],
                },
                tag_list: [],
                isIndeterminate: false,
                checkAll: false,

                tableData: [],

                total: 0,
                currentPage: 1,
                pageSize: 25,

                synchronization: {}, // 同步信息
                sync_loading: false,
                first_update: true,

                dialogVisible: false,
                edit_form: {
                    title: ''
                },
                old_index: -1,
                edit_rules: {
                    title: [{required: true,
                        message: '请输入视频名称！',
                        trigger: 'blur'}],
                }
            };
        },
        computed: {
            ...mapState("comInformationData", ["videoClassifyList"]),
        },
        mounted() {
            this.getClassifyList();
            this.getTagList();
            this.getTableData();
        },
        methods: {
            ...mapMutations("comInformationData", ["setVideoClassifyList"]),
            getTableHeight() {
                let page_h = document.getElementById("page").offsetHeight;
                let header_h = document.getElementById("header").offsetHeight;
                let bottom_h = document.getElementById("bottom_page").offsetHeight;
                this.tableHeight = page_h - header_h - bottom_h;
            },
            getClassifyList() {
                // 获取视频分类
                let params = {
                    dict_name: "视频分类",
                };
                this.httpGet("/cdict/list", params).then((res) => {
                    this.setVideoClassifyList(res.data);
                });
            },
            getTagList() {
                this.httpGet("/video/tag").then((res) => {
                    this.tag_list = res.data;
                    this.$nextTick(() => {
                        this.getTableHeight();
                    });
                });
            },
            handleCheckAllChange(val) {
                this.searchForm.tags = val ? this.tag_list : [];
                this.isIndeterminate = false;
                this.getTableData();
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.tag_list.length;
                this.isIndeterminate =
                    checkedCount > 0 && checkedCount < this.tag_list.length;
                this.getTableData();
            },

            showImgUrl(item) {
                return item.thumb_file_path_url;
            },
            clearSearch(val) {
                this.searchForm[val] = "";
                this.getTableData();
            },
            changeCell(item, val) {
                this.searchForm[val] = item;
                this.getTableData();
            },
            uploadVideo() {
                this.$emit("changeTopTab", "addView");
            },
            edit_item(item, index) {
                this.edit_form = clone(item);
                this.old_index = index;
                this.dialogVisible = true
            },
            del_item(item) {
                // console.log(item, '183');
                const that = this;
                this.$confirm('确定要删除该视频么？').then(() => {
                    this.httpDel(`/video/${item.video_id}`).then((res) => {
                        that.$message.success("删除成功！");
                        let now_total = that.tableData.length;
                        let page = that.currentPage;
                        let now_page = page == 1 ? 1 : now_total == 1 ? page - 1 : page;
                        that.getTableData(now_page);
                        this.getTagList();
                    });
                }).catch(() => {})
            },
            submitEdit() {
                const that = this;
                this.$refs.edit_form.validate(valid => {
                    if(valid) {
                        let params = {
                            ...this.edit_form
                        };
                        that.httpPost(`/video/${params.video_id}`, params).then((res) => {
                            that.$message.success("修改成功！");
                            that.dialogVisible = false;
                            that.tableData[this.old_index] = clone(this.edit_form);
                            that.$forceUpdate();
                        });
                    }
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val);
            },
            getTableData(val = 1) {
                let params = {
                    page: val,
                    page_size: this.pageSize,
                    cates: this.searchForm.classification,
                    name: this.searchForm.input,
                    tags: this.searchForm.tags,
                };
                this.httpPost("/video/list", params).then((res) => {
                    this.tableData = res.data.data_list;
                    this.tableData.map((v) => {
                        v.inputVisible = false;
                        v.inputValue = "";
                        v.url = getQrImageUrl(`/video/qrcode/${v.video_id}`);
                    });
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = val;
                    });
                });
            },
            lookRow(row) {
            },

            select_class(items, item, index) {
                let params = {
                    cate: items,
                };
                this.httpPost(`/video/${item.video_id}`, params).then((res) => {
                    item.cate = items;
                    this.$forceUpdate();
                });
            },
            handleClose(tag, item, index) {
                item.tags.splice(item.tags.indexOf(tag), 1);
                this.submitTags(item, 'del');
            },

            showInput(item, index) {
                item.inputVisible = true;
                this.$forceUpdate();
                this.$nextTick((_) => {
                    this.$refs.saveTagInput[0].$refs.input.focus();
                });
            },
            changeInput() {
                this.$forceUpdate();
            },
            handleInputConfirm(item, index) {
                let inputValue = item.inputValue;
                if (inputValue) {
                    item.tags.push(inputValue);
                }
                item.inputVisible = false;
                item.inputValue = "";
                this.$forceUpdate();
                this.submitTags(item);
            },
            submitTags(item, type = '') {
                let params = {
                    tags: item.tags,
                };
                this.httpPost(`/video/${item.video_id}`, params).then((res) => {
                    this.$forceUpdate();
                    this.getTagList();
                    if (type === 'del') {
                        this.searchForm.tags = [];
                        this.isIndeterminate = false;
                        this.checkAll = false;
                    }
                }).catch(err => {
                    if(err.code === 1002) {
                        this.$message.warning(err.msg);
                        item.tags.splice(item.tags.length -1, 1)
                    }
                });
            },
            openScoreEdit(item) {
                item.showScoreEdit = true;
                this.$forceUpdate()
            },

            changeScore(item) {
                let params = {
                    score: item.score
                };
                this.httpPost(`/video/${item.video_id}`, params).then(res => {
                    item.showScoreEdit =false;
                    this.$forceUpdate();
                })
            },
        },
    };
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        position: relative;
        display: flex;
        flex-flow: column;

        .header {
            display: flex;
            .search_box {
                flex: 1;
                padding: 5px 10px;
                box-sizing: border-box;
                .radio_box {
                    display: flex;
                    line-height: 30px;
                    .search_btn {
                        padding-left: 15px;
                    }
                }
                .input_box {
                    display: flex;
                    flex-flow: wrap;
                    .btn {
                        height: 25px;
                        line-height: 25px;
                        font-size: 0.875rem;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin: 7px 10px;
                        cursor: pointer;
                        color: #606266;
                    }
                    .actived_btn {
                        box-sizing: border-box;
                        border: 1px solid #38adff;
                        border-radius: 3px;
                    }
                }
                .check_box {
                    display: flex;
                    .all_check {
                        flex: 0 0 80px;
                    }
                    .check_btn {
                        flex: 1;
                    }
                }
            }
            .btn_box {
                display: flex;
                padding: 5px 10px;
                box-sizing: border-box;
                .btn {
                    flex: 0 0 80px;
                }
            }
        }
        .table_box {
            flex: 1;
            width: 100%;
            padding: 0 10px;
            overflow: hidden;
            overflow-y: auto;
            box-sizing: border-box;
            border-bottom: 1px solid #ddd;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            align-content: flex-start;
            .card_item {
                width: 320px;
                min-height: 120px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                line-height: 30px;
                .title {
                    padding: 0 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .flex_box {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    /*height: 30px;*/
                    .title_f {
                        flex: 0 0 60px;
                    }
                    .text_f {
                        flex: 1;
                    }
                    .select {
                        .add_class {
                            font-size: 1.125rem;
                            cursor: pointer;
                            padding: 0 5px;
                            border: 1px solid #8d8d8d;
                            border-radius: 3px;
                            box-sizing: border-box;
                        }
                    }
                    .tags {
                        display: flex;
                        flex-flow: wrap;
                        margin-bottom: 3px;
                        .tag_item {
                            margin: 2px 0 2px 5px;
                            border: none;
                            background: #ebeef5;
                            color: #606266;
                        }
                        .button-new-tag {
                            margin: 2px 0 2px 5px;
                            padding-top: 5px;
                            padding-bottom: 5px;
                        }
                        .input-new-tag {
                            margin: 0 0 0 5px;
                            width: 90px;
                            vertical-align: bottom;
                            height: 28px;
                        }
                    }
                }
                .bottom_flex {
                    margin-bottom: 5px;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                }

                .icon_box {
                    .click_icon {
                        padding: 0 5px;
                        cursor: pointer;
                        font-size: 16px;
                        display: none;
                    }
                }
                &:hover {
                    .icon_box {
                        .click_icon {
                            display: inline;
                        }
                    }
                }
            }
        }
        .bottom_page {
            flex: 0 0 50px;
            box-sizing: border-box;
            padding-top: 10px;
            width: 100%;
            text-align: center;
        }
    }
</style>
<style lang="scss">
    .tag_item {
        .el-tag__close {
            color: #606266;
            &:hover {
                color: #fff;
                background-color: #606266;
            }
        }
    }
</style>